import React from 'react';
import { useSelector } from 'react-redux';
import { persistPageBeforeLogin } from '@/utils';
import { RootState } from '@/redux/reducers';
import Account from '@/components/Account';
import './styles.less';

interface AuthDropdownProps {
  componentNotLoginYet: HTMLElement | React.ReactNode;
  textColor?: string;
  iconUser?: string;
}

const AuthDropdown: React.FC<AuthDropdownProps> = ({
  componentNotLoginYet,
  textColor,
  iconUser,
}) => {
  const authUser = useSelector((state: RootState) => state.authUser.data);

  return authUser ? (
    <Account textColor={textColor} iconUser={iconUser} />
  ) : (
    <button onClick={persistPageBeforeLogin}>{componentNotLoginYet}</button>
  );
};

export default AuthDropdown;
